import { z } from 'src/lib'
import { schemaEntityWithId } from 'src/types'

export const EtapaPermisoFields = {
    IdGrupo: 'idGrupo',
    PermisoTipo: 'permisoTipo'
} as const

export const EtapaViewFields = {
    CodSistema: 'codSistema',
    CodSistemaPrincipal: 'codSistemaPrincipal',
    NombreEtapa: 'nombre',
    DiasDuracion: 'diasDuracion',
    CostoBase: 'costoBase',
    CostoDiario: 'costoDiario',
    TipoEtapa: 'tipoEtapa',
    IdEtapaVirtual: 'idEtapaVirtual',
    Orden: 'orden',
    CoordenadaX: 'posX',
    CoordenadaY: 'posY',
    NombreSistema: 'nombreSistema',
    NombreSistemaPrincipal: 'nombreSistemaPrincipal',
    Permisos: 'permisos'
} as const

export const EtapaPostFields = {
    CodSistema: 'codSistema',
    NombreEtapa: 'nombre',
    DiasDuracion: 'diasDuracion',
    CostoBase: 'costoBase',
    CostoDiario: 'costoDiario',
    TipoEtapa: 'tipoEtapa',
    IdEtapaVirtual: 'idEtapaVirtual',
    Orden: 'orden',
    Permisos: 'permisos'
} as const

export const EtapaPermisoPostFields = {
    IdGrupo: 'idGrupo',
    PermisoTipo: 'permisoTipo'
} as const

export const schemaEtapaPermisoViewDTO = z
    .object({
        [EtapaPermisoFields.IdGrupo]: z.number(),
        [EtapaPermisoFields.PermisoTipo]: z.number()
    })
    .merge(schemaEntityWithId)

export const schemaEtapaViewDTO = z
    .object({
        [EtapaViewFields.CodSistema]: z.number(),
        [EtapaViewFields.CodSistemaPrincipal]: z.number(),
        [EtapaViewFields.NombreEtapa]: z.string(),
        [EtapaViewFields.DiasDuracion]: z.number(),
        [EtapaViewFields.CostoBase]: z.number(),
        [EtapaViewFields.CostoDiario]: z.number(),
        [EtapaViewFields.TipoEtapa]: z.string(),
        [EtapaViewFields.IdEtapaVirtual]: z.number(),
        [EtapaViewFields.Orden]: z.number(),
        [EtapaViewFields.NombreSistema]: z.string().nullable(),
        [EtapaViewFields.NombreSistemaPrincipal]: z.string().nullable(),
        [EtapaViewFields.Permisos]: z.array(schemaEtapaPermisoViewDTO).nullable()
    })
    .merge(schemaEntityWithId)

const schemaEtapaPermisoPostDTO = z.object({
    [EtapaPermisoPostFields.IdGrupo]: z.number(),
    [EtapaPermisoPostFields.PermisoTipo]: z.number()
})

export const schemaEtapaPostDTO = z.object({
    [EtapaPostFields.CodSistema]: z.number(),
    [EtapaPostFields.NombreEtapa]: z.string(),
    [EtapaPostFields.DiasDuracion]: z.number(),
    [EtapaPostFields.CostoBase]: z.number(),
    [EtapaPostFields.CostoDiario]: z.number(),
    [EtapaPostFields.TipoEtapa]: z.string(),
    [EtapaPostFields.IdEtapaVirtual]: z.number(),
    [EtapaPostFields.Orden]: z.number(),
    [EtapaPostFields.Permisos]: z.array(schemaEtapaPermisoPostDTO).nullable()
})

export type EtapaPostDTO = z.infer<typeof schemaEtapaPostDTO>

export const EtapaRequestFields = {
    CodSistemaPrincipal: 'codSistemaPrincipal',
    CodMensajeTipo: 'codMensajeTipo',
    Nombre: 'nombreEtapa'
} as const

export const schemaEtapaRequestDTO = z.object({
    [EtapaRequestFields.CodSistemaPrincipal]: z.number().optional(),
    [EtapaRequestFields.CodMensajeTipo]: z.number().optional(),
    [EtapaRequestFields.Nombre]: z.string().optional()
})

export type EtapaRequestDTO = z.infer<typeof schemaEtapaRequestDTO>
